<lsq-button
    id="download-all-btn"
    [style.display]="'block'"
    [size]="'sm'"
    appearance="primary"
    (click)="downloadAll()"
>
    {{ label }}
</lsq-button>
